import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import OtpLogin from "@/components/OtpLogin";

export default function TenantLogin() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { setUser, setTenant } = useAuth();
  const [storefront, setStorefront] = useState(null);

  useEffect(() => {
    api.get(`/store/${slug}`).then(({ data }) => setStorefront(data)).catch(() => {});
  }, [slug]);

  const brand = storefront?.branding?.primary_color || "#0F172A";

  return (
    <div className="min-h-screen lg:grid lg:grid-cols-2 bg-slate-50">
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-white grid-bg">
        <div>
          <div className="flex items-center gap-3 mb-12">
            {storefront?.branding?.logo_url ? (
              <img src={storefront.branding.logo_url} alt="logo" className="h-12 w-12 object-contain bg-white rounded p-1 border border-slate-200" />
            ) : (
              <div className="w-10 h-10 rounded bg-slate-900 grid place-items-center text-white font-bold">R</div>
            )}
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500">Tenant Admin</div>
              <div className="font-display text-xl font-bold">{storefront?.name || "Loading..."}</div>
            </div>
          </div>
          <h1 className="font-display text-4xl font-extrabold tracking-tight max-w-md text-slate-900">
            Manage your rental business
          </h1>
          <p className="mt-4 text-slate-600 max-w-md">Products, orders, sellers, offers and reports — everything in one place.</p>
        </div>
        <div className="text-xs text-slate-500">
          <Link to={`/t/${slug}`} className="underline" data-testid="tenant-login-back-storefront">← Back to storefront</Link>
        </div>
      </div>

      {/* Mobile header */}
      <div className="lg:hidden bg-white border-b border-slate-200 px-5 py-4 flex items-center gap-3" data-testid="tenant-login-mobile-header">
        {storefront?.branding?.logo_url ? (
          <img src={storefront.branding.logo_url} alt="logo" className="h-10 w-10 object-contain bg-white rounded p-1 border border-slate-200" />
        ) : (
          <div className="w-9 h-9 rounded bg-slate-900 grid place-items-center text-white font-bold text-sm">R</div>
        )}
        <div className="flex-1">
          <div className="font-display text-base font-bold leading-none truncate">{storefront?.name || "Tenant Admin"}</div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5">Tenant Admin Login</div>
        </div>
        <Link to={`/t/${slug}`} className="text-xs text-slate-500 underline" data-testid="tenant-login-back-storefront-mobile">Storefront</Link>
      </div>

      <div className="flex items-start sm:items-center justify-center px-4 sm:px-6 py-6 sm:py-10 min-h-[calc(100vh-72px)] lg:min-h-screen">
        <OtpLogin
          scope="tenant"
          tenantSlug={slug}
          title="Sign in to your dashboard"
          subtitle={`Owner / Staff phone — Demo: 9000000011 (aquapure), 9000000022 (drivex), 9000000033 (kasturi)`}
          brandColor={brand}
          testIdPrefix="tenant-login"
          onSuccess={(data) => {
            setUser(data.user);
            setTenant(data.tenant);
            nav(`/tenant/${slug}/admin`);
          }}
        />
      </div>
    </div>
  );
}
